module.exports = __webpack_public_path__ + "static/img/buy.d273e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/buy.png
// module id = h/w3
// module chunks = 58